import React from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { phone } from '../../../../src/shared/format';

const propTypes = {
  number: PropTypes.string.isRequired,
  element: PropTypes.string,
  locale: PropTypes.string,
};

const defaultProps = {
  element: 'a',
  locale: '',
};

const Phone = ({ number, element, locale, ...props }) => {
  const telHref = `tel:${number.replace(/[^\d]+/ig, '')}`;
  const newProps = {
    ...props,
    href: telHref,
  };
  return (
    React.createElement(element, newProps, phone(number, locale))
  );
};

Phone.propTypes = propTypes;
Phone.defaultProps = defaultProps;

Phone.fragments = {
  facility: gql`
    fragment FacilityPhone on Facility {
      phone
    }
  `,
};

export default Phone;
